import { Collapse } from "antd";
import { FacilityType } from "common/types";
import { translate } from "common/utils";
import React from "react";
import { FacilityGroupCollapse, FacilityListView, FacilitySelector, FacilityTitle } from "./styles";
import { SessionStorageKeys } from "common/enums";

const { Panel } = Collapse;

export type FacilityGroupType = {
  name: string;
  id?: string;
  facilities: FacilityType[];
};

type Props = {
  facilityGroups: FacilityGroupType[];
  setFacility: (arg: FacilityType) => void;
};

const FacilityList: React.FC<Props> = ({ facilityGroups, setFacility }) => {
  const facilityCards =
    facilityGroups &&
    facilityGroups.map((group, i) => (
      <Panel key={i.toString()} header={group.name}>
        {group.facilities &&
          group.facilities.map((facility, key) => (
            <FacilitySelector key={key} onClick={e => setFacility(facility)}>
              {facility.name}
            </FacilitySelector>
          ))}
      </Panel>
    ));

  const content = facilityCards && (
    <FacilityListView>
      <FacilityTitle>
        {translate("auth:choose-facility", {
          lng: sessionStorage.getItem(SessionStorageKeys.LANGUAGE)
        })}
      </FacilityTitle>
      <FacilityGroupCollapse accordion={true} defaultActiveKey={["0"]}>
        {facilityCards}
      </FacilityGroupCollapse>
    </FacilityListView>
  );

  return content;
};

export default FacilityList;
